@if (showTable) {
  <snelstart-ui-table [config]="tableConfig">
    <snelstart-ui-table-col
      columnType="string"
      name="label"
      [showFilter]="false"
      [showSort]="false"
      width="600"
      i18n-displayName
    >
      <snelstart-ui-table-col-header>
        <div style="font-size: 13px; color: #00200b ">
          {{ this.title }}
        </div>
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-expanded-row>
        <div *ngFor="let option of options; let i = index;">
          <div *ngFor="let subOnderdeel of option.subonderdelen!; let j = index;">
            <div *ngIf="subOnderdeel.visible">
              <snelstart-ui-button
                icon="chevron-right" type="link" class="ps-5"
                (click)="navigateToSubPage(subOnderdeel)">

                  <div [ngStyle]="subOnderdeel.pageMapping === activePage ? {'color': '#0073dd', 'font-weight': 'bold'} : {}">
                      {{ subOnderdeel.label }}
                  </div>
              </snelstart-ui-button>
            </div>
          </div>
        </div>
      </snelstart-ui-table-expanded-row>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="onderdelenAanvullendeTekst"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="currency"
                            [decimals]="2"
                            i18n-displayName
                            width="300">
      <snelstart-ui-table-col-header></snelstart-ui-table-col-header>
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          <ng-container>
            <a *ngIf="record.value === 1"></a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 2">Waarde schenking:</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 3">Vrijstellingen:</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 4">Belaste schenking:</a>
          </ng-container>
          <ng-container>
            <b><a *ngIf="record.value === 5">Te betalen:</a></b>
          </ng-container>
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

    <snelstart-ui-table-col name="berekening"
                            [showFilter]="false"
                            [showSort]="false"
                            columnType="currency"
                            [decimals]="2"
                            i18n-displayName
                            width="300"
    >
      <snelstart-ui-table-col-header>
        <div style="font-size: 13px; color: #00200b ">
          Schenking
        </div>
      </snelstart-ui-table-col-header>

      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
          <ng-container>
            <a *ngIf="record.value === 1"></a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 2">{{ (this.totaleSchenking || 0 ).toLocaleString()}}</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 3">{{ (this.benutteVrijstellingen || 0 ).toLocaleString()  }}</a>
          </ng-container>
          <ng-container>
            <a *ngIf="record.value === 4">{{ (this.totaleBelastbareSchenking || 0 ).toLocaleString() }}</a>
          </ng-container>
          <ng-container>
            <b>
              <a *ngIf="record.value === 5">{{ (this.verschuldigdeSchenkbelasting || 0 ).toLocaleString() }}</a>
            </b>
          </ng-container>
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>

  </snelstart-ui-table>
  <snelstart-venture-fiscaal-domain-logic-service [(dialogVisible)]="this.dialogVisible"
                                                  [title]="'Nieuwe aangifte schenkbelasting aanmaken'"
  >
  </snelstart-venture-fiscaal-domain-logic-service>
}
